// @ts-nocheck
import type * as Types from '../types/graphql/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PageFragmentFragment = { __typename?: 'Page', id: string, title: string, imageUrl: string, status: Types.PageStatus, slug?: string | null, fundraisersTitle: string, defaultDonorCoverFeesValue: boolean, color: string, pageFeatures: { __typename?: 'PageFeatures', communityTab: boolean, peerToPeerTab: boolean, allocations: boolean, donationAmount: boolean, chariotButton: boolean, addressForm: boolean, donorCoversFees: boolean } };

export type PagesQueryVariables = Types.Exact<{
  workspaceId: Types.Scalars['ID']['input'];
}>;


export type PagesQuery = { __typename?: 'Query', pages: Array<{ __typename?: 'Page', id: string, title: string, imageUrl: string, status: Types.PageStatus, slug?: string | null, fundraisersTitle: string, defaultDonorCoverFeesValue: boolean, color: string, pageFeatures: { __typename?: 'PageFeatures', communityTab: boolean, peerToPeerTab: boolean, allocations: boolean, donationAmount: boolean, chariotButton: boolean, addressForm: boolean, donorCoversFees: boolean } }> };

export const PageFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment PageFragment on Page {
  id
  title
  imageUrl
  status
  slug
  fundraisersTitle
  defaultDonorCoverFeesValue
  pageFeatures {
    communityTab
    peerToPeerTab
    allocations
    donationAmount
    chariotButton
    addressForm
    donorCoversFees
  }
  color
}
    `;
export const PagesDocument = /*#__PURE__*/ gql`
    query Pages($workspaceId: ID!) {
  pages(workspaceId: $workspaceId) {
    ...PageFragment
  }
}
    ${PageFragmentFragmentDoc}`;

/**
 * __usePagesQuery__
 *
 * To run a query within a React component, call `usePagesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePagesQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function usePagesQuery(baseOptions: Apollo.QueryHookOptions<PagesQuery, PagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PagesQuery, PagesQueryVariables>(PagesDocument, options);
      }
export function usePagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PagesQuery, PagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PagesQuery, PagesQueryVariables>(PagesDocument, options);
        }
export function usePagesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PagesQuery, PagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PagesQuery, PagesQueryVariables>(PagesDocument, options);
        }
export type PagesQueryHookResult = ReturnType<typeof usePagesQuery>;
export type PagesLazyQueryHookResult = ReturnType<typeof usePagesLazyQuery>;
export type PagesSuspenseQueryHookResult = ReturnType<typeof usePagesSuspenseQuery>;
export function refetchPagesQuery(variables: PagesQueryVariables) {
      return { query: PagesDocument, variables: variables }
    }